<!-- 안전리더십 > 종합점수 -->
<template>
  <Loading v-if="isLoading" />
  <div class="tabCont">
    <div class="content-inner-box page2-inner3">
      <div class="tit-group ty01">
        <h4 class="tit">{{ leadershipAllList.leadershipList && leadershipAllList.leadershipList.length > 0?leadershipAllList.leadershipList[0].leadershipTitle:'' }}</h4>
        <div class="btn-group">
          <c-btnMenu01 v-bind="btnDownloadBind" @on-click-child="onClickChild"/>
        </div>
      </div>

      <div class="tit-group02 inner-ty">
        <h2 class="tit"></h2>
        <div class="filter-btn-group">
          <v-btn class="reset" :class="filterDiv1" @click="onClickInitFilter">{{t('message.filterInit')}}</v-btn>
          <v-btn class="filter" @click="filterOpen1" :class="filterDiv1">{{t('message.filter')}}</v-btn>
        </div>
      </div>
      <div class="form-group col-ty">
        <!--form-row-->
        <div class="form-row" :class="filterDiv1">
          <div class="row">
            <div class="col">
              <Select v-bind="deptSelect" v-model="deptModel"/>
            </div>
            <div class="col">
              <Select v-bind="posSelect" v-model="posModel"/>
            </div>
            <div class="col">
              <Select v-bind="memberSelect" v-model="memberModel"/>
            </div>
            <div class="col">
              <Select v-bind="leadershipSelect" v-model="leadershipModel"/>
            </div>
          </div>
        </div>

        <div class="form-row scrollbar">
          <div class="row">
            <div class="tbl-group line-ty tbl-fixed c02">
              <v-table v-if="groupedContentList && groupedContentList.length > 0">
                <thead>
                <tr>
                  <th rowspan="2" colspan="2">{{t('message.name')}}</th>
                  <th rowspan="2">{{t('message.sumLS')}}</th>
                  <template v-for="group in groupedContentList" :key="'group-' + group.groupKey">
                    <th class="t1" :colspan="group.children.length">
                      {{ group.parentTitle }}
                    </th>
                  </template>
                </tr>
                <tr>
                  <th v-for="contentRow in contentList" :key="contentRow.idx">{{contentRow.contentTitle}}</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="memberRow in contentMemberList" :key="memberRow.memberIdx">
                  <td class="td-size3">
                    {{ memberRow.memberName }}
                  </td>
                  <td class="td-btn">
                    <div class="txt-group flex-c" v-if="memberRow.fileCnt > 0">
                      <BtnIcon class="btn-ico-result" @click="onClickFileListPopup(memberRow)"/>
                    </div>
                  </td>
                  <td>{{ Math.round(memberRow.totalScore) }}</td>
                  <td v-for="(score, index) in memberRow.scores" :key="index">{{Math.round(score)}}</td>
                </tr>
                </tbody>
              </v-table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <v-snackbar v-model="snackbar" :timeout="3000" location="center" class="custom-snackbar"> {{ snackText }} </v-snackbar>

  <!--popup: 결과물 보기-->
  <DialogDetailView
    v-model="DialogDetailViewModel"
    @close="DialogDetailViewModel=false"
  />
</template>

<script setup lang="ts">
import {ref, onMounted, watch} from 'vue'
import { storeToRefs } from 'pinia'
import { useCommonStore } from "@/store/common";
import LeadershipService from "@/services/leadership.service";
import utils from "@/common/Utils";
import _ from 'lodash';
import { useI18n } from 'vue-i18n';
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import CompanyService from "@/services/company.service";
import * as XLSX from "xlsx";
import dayjs from "dayjs";
const { t } = useI18n();

//store
const store = useCommonStore()
const storeRef = storeToRefs(store)
const route:any = useRoute()

//define
const props = defineProps({isActive: Boolean})

//bind
const isLoading = ref<boolean>(false)
const snackbar = ref(false)
const snackText = ref('')
let viewIdx = route.params.idx!='null'?route.params.idx:''
const memberSelect = ref({items: [{name:t('message.individual'), value:''}]})
const deptSelect = ref({items: [{name:t('message.department'), value:''}]})
const posSelect = ref({items: [{name:t('message.position'), value:''}]})
const leadershipSelect = ref({items: [{name:t('message.safetyLeadership'), value:''}]})
const memberModel = ref('')
const deptModel = ref('')
const posModel = ref('')
const leadershipModel = ref('')
const filterDiv1 = ref('off')
const leadershipAllList:any = ref([])
const contentList:any = ref([])
const groupedContentList:any = ref([])
const contentMemberList:any = ref([])
const DialogDetailViewModel = ref(false)

//hook
onMounted(() => {
})

//ui
const btnDownloadBind = {
  btnText: t('message.download'),
  setItems: [
    { title: t('message.summaryReport') },
    { title: t('message.freeForm') },
    { title: t('message.quizFormat') },
    { title: t('message.monitoringFormat') }
  ],
}

const contentTypeKeyMap = {
  1: 'message.freeForm',
  2: 'message.quizFormat',
  3: 'message.selfMonitoring',
  4: 'message.peerMonitoring',
}

const criteriaTypeFreeBoardKeyMap = {
  1: 'message.open',
  4: 'message.attach',
}

const criteriaTypeKeyMap = {
  1: 'message.execution',
  2: 'message.score',
  3: 'message.safetyBehaviorRate'
}

const behaviorTypeKeyMap = {
  1: 'message.countType',
  2: 'message.singleChoiceType2',
  3: 'message.likertBarsType',
  4: 'message.barsType',
  5: 'message.multipleChoiceType',
  6: 'message.otherType',
}

//computed
const contentType = computed(()=>(type:any) => {
  let result = ''
  if (type === '1') result = t('message.freeForm')
  if (type === '2') result = t('message.quiz')
  if (type === '3') result = t('message.selfMonitoring')
  if (type === '4') result = t('message.peerMonitoring')
  if (type === '5') result = t('message.merge')

  return result
})

//function
const getFilter=async()=>{
  //본인부서에 해당하는 모니터링, 부서, 맴버정보
  const companyIdx = localStorage.getItem('companyIdx')
  let params = {companyIdx: companyIdx, actionType:'2'}
  try{
    const response:any = await LeadershipService.getLeadershipFilter(params)
    //모니터링필터
    let leadershipList = response.result.leadershipList
    leadershipSelect.value = {items:[]}
    _.forEach(leadershipList, function (item){
      leadershipSelect.value.items.push({name:item.leadershipTitle, value:item.idx})
      if(viewIdx == item.idx)
        leadershipModel.value = item.idx
    })
    //부서필터
    let deptList = response.result.deptList
    deptSelect.value = {items:[{name:t('message.department'), value:''}]}
    _.forEach(deptList, function (item){
      deptSelect.value.items.push({name:item.treeName, value:item.idx})
    })
    let posList = response.result.posList
    posSelect.value = {items:[{name:t('message.position'), value:''}]}
    _.forEach(posList, function (item){
      posSelect.value.items.push({name:item.treeName, value:item.idx})
    })
    //맴버필터
    let memberList = response.result.memberList
    memberSelect.value = {items:[{name:t('message.individual'), value:''}]}
    _.forEach(memberList, function (item){
      memberSelect.value.items.push({name:item.memberName, value:item.idx})
    })
  }
  catch(error){
    if(error.status == 403)
      utils.movePage('/login')
    else{
      snackText.value = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
      snackbar.value = true
    }
  }
}

const getSummary=async()=>{
  isLoading.value = true
  let companyIdx = localStorage.getItem('companyIdx')
  let params = {
    companyIdx:companyIdx,
    memberIdx:memberModel.value,
    deptIdx:deptModel.value,
    posIdx:posModel.value,
    leadershipIdx:leadershipModel.value||viewIdx,
    groupType:'member'
  }
  try{
    const response = await LeadershipService.getLeadershipSummary(params)
    leadershipAllList.value = response.result

    // 1. 전체 콘텐츠 목록 병합
    const mergedContentList = _.flatMap(leadershipAllList.value.leadershipList, 'leadershipContentList')

    // 2. 고유 콘텐츠 목록 (content idx 기준, 중복 제거)
    const contentGrouped = _.groupBy(mergedContentList, 'idx')

    const allContents = Object.entries(contentGrouped).map(([idx, items]) => {
      const first = items[0]
      return {
        idx: Number(idx),
        contentTitle: first.contentTitle,
        contentType: contentType.value(first.contentType),
        parentIdx:first.parentIdx,
        mergeYn:first.mergeYn
      }
    })
    contentList.value = allContents  // columns 용
    //그룹머지
    groupedContentList.value = _(contentList.value)
      .groupBy(row => row.mergeYn === 'Y' && row.parentIdx !== 0 ? row.parentIdx : row.idx)
      .map((items, groupKey) => {
        let parentTitle = items[0].contentType
        if(items.length > 1)
          parentTitle = contentType.value('5')
        return {
          groupKey,
          parentTitle,
          children: items,
        }
      })
      .value()

    // 3. performerIdx별로 그룹핑
    const groupedByPerformer = _.groupBy(mergedContentList, 'performerIdx')

    // 4. performer별로 점수 계산
    const rows = Object.entries(groupedByPerformer).map(([performerIdx, contents]) => {
      const memberName = contents[0]?.memberName || ''
      const memberId = contents[0]?.memberId || ''
      const deptName = contents[0]?.deptName || ''
      const posName = contents[0]?.posName || ''
      const fileCnt = contents[0]?.fileCnt || 0
      const idx = contents[0]?.idx || 0
      const contentScoreGroup = _.groupBy(contents, 'idx')

      // scores: 각 content.idx에 대한 합산 점수 (null 제외)
      const scores = allContents.map(content => {
        const entries = contentScoreGroup[content.idx] || []
        const totalScore = entries.reduce((sum, entry) => {
          return sum + (typeof entry.weightedScore === 'number' ? entry.weightedScore : 0)
        }, 0)
        return entries.length > 0 ? totalScore : null
      })

      const totalScore = scores.reduce((sum, score) => {
        return sum + (typeof score === 'number' ? score : 0)
      }, 0)

      return {
        performerIdx: Number(performerIdx),
        memberName: `${memberName} (${memberId})\n${deptName} / ${posName}`,
        fileCnt: fileCnt,
        idx: idx,
        scores,
        totalScore,
      }
    })

    contentMemberList.value = rows  // rows 용

    isLoading.value = false
  }
  catch(error){
    isLoading.value = false
    if(error.status == 403)
      utils.movePage('/login')
    else{
      snackText.value = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
      snackbar.value = true
    }
  }
}

const filterOpen1=()=>{
  if(filterDiv1.value == 'off')
    filterDiv1.value = 'on'
  else
    filterDiv1.value = 'off'
}

const onClickInitFilter=()=>{

}

//pdf다운로드 -> 사용안함
/*
const onClickDownload = async()=>{
  await nextTick(); // Vue에서 DOM 그려진 후 실행

  const element = document.querySelector('.page2') as HTMLElement;
  if (!element) return;

  const canvas = await html2canvas(element, {
    useCORS: true,
    scale: 2,
    allowTaint: true,
  });

  const imgData = canvas.toDataURL('image/png');

  const pdf = new jsPDF({
    orientation: 'portrait',
    unit: 'mm',
    format: 'a4',
  });

  const pageWidth = pdf.internal.pageSize.getWidth();  // 210mm
  const pageHeight = pdf.internal.pageSize.getHeight(); // 297mm

  // px to mm 비율 계산
  const pxPerMm = canvas.width / pageWidth;

  // 실제 이미지의 크기(mm 기준)
  const imgHeightMm = canvas.height / pxPerMm;

  let remainingHeight = imgHeightMm;
  let position = 0;

  // 한 페이지에 그릴 이미지 높이(px 기준)
  const pageHeightPx = pageHeight * pxPerMm;

  while (remainingHeight > 0) {
    const canvasPage = document.createElement('canvas');
    canvasPage.width = canvas.width;
    canvasPage.height = Math.min(pageHeightPx, canvas.height - position);

    const ctx = canvasPage.getContext('2d');
    if (ctx) {
      ctx.drawImage(
        canvas,
        0, position,                        // Source X, Y
        canvas.width, canvasPage.height,   // Source Width, Height
        0, 0,                               // Dest X, Y
        canvas.width, canvasPage.height    // Dest Width, Height
      );

      const pageImgData = canvasPage.toDataURL('image/png');
      pdf.addImage(pageImgData, 'PNG', 0, 0, pageWidth, canvasPage.height / pxPerMm);
    }

    remainingHeight -= pageHeight;
    position += pageHeightPx;

    if (remainingHeight > 0) {
      pdf.addPage();
    }
  }

  pdf.save('leadershipReport.pdf');
}
*/

//다운로드 버튼 콜백
const onClickChild=(item)=>{
  if(item == t('message.summaryReport')){
    excelDownload('summary')
  }
  else if(item == t('message.freeForm')){
    excelDownload('freeboard')
  }
  else if(item == t('message.quizFormat')){
    excelDownload('quiz')
  }
  else if(item == t('message.monitoringFormat')){
    excelDownload('monitoring')
  }
}

const excelDownload=async(type)=>{
  if(type=='summary'){
    const wb = XLSX.utils.book_new()
    /** 안전하게 값 꺼내기 (ref 대응) */
    const groups = _.get(groupedContentList, 'value', groupedContentList)
    const contents = _.get(contentList, 'value', contentList)
    const members = _.get(contentMemberList, 'value', contentMemberList)

    /* ---------------------------
       1️⃣ 헤더 1행 (그룹)
    --------------------------- */
    const headerRow1 = [t('message.name'), t('message.sumLS')]
    _.forEach(groups, g => {
      headerRow1.push(g.parentTitle)
      _.times((g.children?.length || 1) - 1, () => headerRow1.push(''))
    })

    /* ---------------------------
       2️⃣ 헤더 2행 (콘텐츠명)
    --------------------------- */
    const headerRow2 = ['', '']
    _.forEach(contents, c => headerRow2.push(c.contentTitle))

    /* ---------------------------
       3️⃣ 데이터 행
    --------------------------- */
    const dataRows = _.map(members, m => ([
      m.memberName,
      Math.round(m.totalScore || 0),
      ..._.map(m.scores, s => Math.round(_.defaultTo(s, 0)))
    ]))

    /* ---------------------------
       4️⃣ 시트 생성
    --------------------------- */
    const ws = XLSX.utils.aoa_to_sheet([headerRow1, headerRow2, ...dataRows])

    /* ---------------------------
       5️⃣ 병합 설정 (화면과 동일)
    --------------------------- */
    ws['!merges'] = [
      { s: { r: 0, c: 0 }, e: { r: 1, c: 0 } },
      { s: { r: 0, c: 1 }, e: { r: 1, c: 1 } }
    ]

    let col = 2
    _.forEach(groups, g => {
      const span = g.children?.length || 1
      if (span > 1) {
        ws['!merges'].push({
          s: { r: 0, c: col },
          e: { r: 0, c: col + span - 1 }
        })
      }
      col += span
    })

    /** -----------------------
     * 5️⃣ 엑셀 추가 및 저장
     ----------------------- */
    XLSX.utils.book_append_sheet(wb, ws, 'summary')
    XLSX.writeFile(wb, `leadership_summary_${dayjs().format('YYYYMMDD')}.xlsx`)
  }
  else{
    try{
      let companyIdx = localStorage.getItem('companyIdx')
      let params = {companyIdx: companyIdx, leadershipIdx:leadershipModel.value||viewIdx, excelType:type}
      const response = await LeadershipService.getLeadershipResultExcelList(params)

      if(response.success) {
        const wb = XLSX.utils.book_new()
        let dataWS = null
        //엑셀포멧 변경
        if (type == 'freeboard') {
          const list = response.result?.freeBoardExcelList ?? []
          if (!list.length) {
            snackText.value = t('message.noRegisteredData')
            snackbar.value = true
            return
          }
          const computedList = computed(() => {
            return list.map(item => ({
              ...item,
              regDate: item.regDate ? dayjs(item.regDate.substring(0, 19)).format('YYYY-MM-DD HH:mm') : '',
              contentTypeTxt: t(contentTypeKeyMap[item.contentType]) ?? '',
              criteriaTypeTxt: t(criteriaTypeFreeBoardKeyMap[item.criteriaType]) ?? '',
              resultTxt: t(criteriaTypeFreeBoardKeyMap[item.criteriaType]) ?? '',
            }))
          })
          let freeboardJsonData = JSON.parse(JSON.stringify(computedList.value))
          dataWS = XLSX.utils.json_to_sheet(utils.renameKeys(mappingFreeboard, freeboardJsonData))
        } else if (type == 'quiz') {
          const list = response.result?.quizExcelList ?? []
          if (!list.length) {
            snackText.value = t('message.noRegisteredData')
            snackbar.value = true
            return
          }
          const computedList = computed(() => {
            return list.map(item => ({
              ...item,
              regDate: item.regDate ? dayjs(item.regDate.substring(0, 19)).format('YYYY-MM-DD HH:mm') : '',
              contentTypeTxt: t(contentTypeKeyMap[item.contentType]) ?? '',
              criteriaTypeTxt: t(criteriaTypeKeyMap[item.criteriaType]) ?? '',
              answerTxt: item.criteriaType == '2' ? (item.answerScore==0 ? t('message.wrongAnswer') : t('message.correctAnswer')) : '',  //정답 여부 criteriaType 1:공백 2:점수따라 정답,오답
              answerScore: item.criteriaType == '2' ? item.answerScore : t('message.notApplicable'),
              totalScore: item.criteriaType == '2' ? item.answerScore : t('message.notApplicable'),
            }))
          })
          let quizJsonData = JSON.parse(JSON.stringify(computedList.value))
          dataWS = XLSX.utils.json_to_sheet(utils.renameKeys(mappingQuiz, quizJsonData))
        } else if (type == 'monitoring') {
          const list = response.result?.monitoringExcelList ?? []
          if (!list.length) {
            snackText.value = t('message.noRegisteredData')
            snackbar.value = true
            return
          }
          const computedList = computed(() => {
            return list.map(item => ({
              ...item,
              regDate: item.regDate ? dayjs(item.regDate.substring(0, 19)).format('YYYY-MM-DD HH:mm') : '',
              contentTypeTxt: item.contentType?t(contentTypeKeyMap[item.contentType]) ?? '':'',
              criteriaTypeTxt: item.criteriaType?t(criteriaTypeKeyMap[item.criteriaType]) ?? '':'',
              behaviorTypeTxt: item.behaviorType?t(behaviorTypeKeyMap[item.behaviorType]) ?? '':'',
              commentContent: getExcelCommentContent(item),
              answerData: getExcelAnswerData(item),
              answerScore: getExcelAnswerScore(item),
            }))
          })
          let monitoringJsonData = JSON.parse(JSON.stringify(computedList.value))
          dataWS = XLSX.utils.json_to_sheet(utils.renameKeys(mappingMonitoring, monitoringJsonData))
        }
        XLSX.utils.book_append_sheet(wb, dataWS, type)
        XLSX.writeFile(wb, `leadership_${type}_${dayjs().format('YYYYMMDD')}.xlsx`)
      }
      else {
        snackText.value = response.message
        snackbar.value = true
      }
    }
    catch (error) {
      if(error.status == 403)
        utils.movePage('/login')
      else {
        snackText.value = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        snackbar.value = true
      }
    }
  }
}

//모니터링 엑셀 '응답 내용' 정리
const getExcelCommentContent = (item) => {
  switch (item.behaviorType) {
    case '1': // 카운트
      return `${item.answerData??'0'} / ${item.answerData2??'0'}` ?? ''
    case '2': // 선택형
      return item.answerScore === '100'
        ? t('message.safe')
        : t('message.unsafe')
    case '3': // 리커트/bar
    case '4':
    case '5':
    case '6': //comment인데 쿼리에서 commentContent로 넣어서 전달해줌
      return item.commentContent ?? ''
    default:
      return item.commentContent ?? ''
  }
}

//모니터링 엑셀 '응답값' 정리
const getExcelAnswerData = (item) => {
  switch (item.behaviorType) {
    case '1': // 카운트
      return '-'
    case '2': // 선택형
      return '-'
    case '3': // 리커트/bar
    case '4':
      return item.answerData??'-'
    case '5':
    case '6':
      return '-'
    default:
      return item.answerData ?? ''
  }
}

//모니터링 엑셀 '안전행동률' 정리
const getExcelAnswerScore = (item) => {
  switch (item.behaviorType) {
    case '1': // 카운트
      return '-'
    case '2': // 선택형
      return `${item.answerScore}%`
    case '3': // 리커트/bar
    case '4':
      return item.answerData?`${item.answerScore}%`:'-'
    case '5':
    case '6':
      return '-'
    default:
      return item.answerScore ?? ''
  }
}

//컨텐츠 파일리스트
const onClickFileListPopup=async(item)=>{
  let params = {
    contentIdx:item.idx,
    memberIdx:item.performerIdx??item.performerIdx  //팝업idx와 localstorage idx가 다름
  }
  try{
    const response = await LeadershipService.getLeadershipFBFileList(params)
    storeRef.fileList.value = response.result
    DialogDetailViewModel.value = true
  }
  catch(error){
    if(error.status == 403)
      utils.movePage('/login')
    else{
      snackText.value = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
      snackbar.value = true
    }
  }
}

//watch
watch(() => props.isActive, async (val, oldVal) => {
  if (val) {
    await getFilter()
    await getSummary()
  }
},{ immediate: true })

watch(memberModel, (newObj) => {
  if(props.isActive)
    getSummary()
})

watch(deptModel, (newObj) => {
  if(props.isActive)
    getSummary()
})

watch(posModel, (newObj) => {
  if(props.isActive)
    getSummary()
})

watch(leadershipModel, (newObj) => {
  if(props.isActive)
    getSummary()
})

/** 엑셀 다운로드 시 rename될 mapping 양식 */
const mappingFreeboard = {
  regDate:t('message.registrationDate'),  //등록일
  clientName:t('message.companyName'), //회사명
  companyName:t('message.groupName'), //그룹명
  deptName:t('message.department'), //부서
  posName:t('message.position'), //직책
  memberName:t('message.memberName'), //이름
  leadershipTitle:t('message.taskName'), //과제명
  taskTitle:t('message.subTaskName'), //세부 과제명
  contentTitle:t('message.title'), //제목
  contentTypeTxt:t('message.evaluationType'), //평가타입
  criteriaTypeTxt:t('message.evaluationCriteria'), //평가 기준
  resultTxt:t('message.result'), //결과
}
const mappingQuiz = {
  regDate:t('message.registrationDate'),  //등록일
  clientName:t('message.companyName'), //회사명
  companyName:t('message.groupName'), //그룹명
  deptName:t('message.department'), //부서
  posName:t('message.position'), //직책
  memberName:t('message.memberName'), //이름
  leadershipTitle:t('message.taskName'), //과제명
  taskTitle:t('message.subTaskName'), //세부 과제명
  contentTitle:t('message.title'), //제목
  contentTypeTxt:t('message.evaluationType'), //평가타입
  criteriaTypeTxt:t('message.evaluationCriteria'), //평가 기준
  questionTitle:t('message.quizContent'), //퀴즈 내용
  exampleTitle:t('message.answerValue'), //응답값
  answerTxt:t('message.answerYn'), //정답 여부 : 정답,오답 (criteriaType 1:공백 3:점수따라)
  answerScore:t('message.score'), //점수
  totalScore:t('message.finalScore'), //최종 점수
}
const mappingMonitoring = {
  regDate:t('message.registrationDate'),  //등록일
  clientName:t('message.companyName'), //회사명
  companyName:t('message.groupName'), //그룹명
  deptName:t('message.department'), //부서
  posName:t('message.position'), //직책
  leadershipTitle:t('message.taskName'), //과제명
  taskTitle:t('message.subTaskName'), //세부 과제명
  contentTitle:t('message.title'), //제목
  contentTypeTxt:t('message.evaluationType'), //평가타입
  criteriaTypeTxt:t('message.evaluationCriteria'), //평가 기준
  memberName:t('message.observer'), //관찰차
  targetMemberName:t('message.observee'), //피관찰자
  behaviorTypeTxt:t('message.type'), //타입
  behaviorTitle:t('message.behaviorName'), //행동명
  commentContent:t('message.answerContent'), //응답 내용
  answerData:t('message.answerValue'), //응답값
  answerScore:t('message.score'), //안전행동률
}
</script>


<style lang="scss" >
</style>
